import { createStore, applyMiddleware, compose } from 'redux';
import createSagaMiddleware from 'redux-saga';
import createRootReducer from './rootReducer';
import sagas from './rootSagas';
const sagaMiddleware = createSagaMiddleware();
const configureStore = (initialState = {}) => {
    const middleware = [sagaMiddleware];
    const enhancers = [applyMiddleware(...middleware)];
    const composeEnhancers = process.env.NODE_ENV !== 'production' &&
        typeof window === 'object' &&
        window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
        ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
            shouldHotReload: false,
        })
        : compose;
    /* eslint-enable */
    const store = createStore(createRootReducer, initialState, composeEnhancers(...enhancers));
    sagaMiddleware.run(sagas);
    return store;
};
export default configureStore;
